import { render, staticRenderFns } from "./PatientFrictionPage.vue?vue&type=template&id=113ed015&scoped=true"
import script from "./PatientFrictionPage.vue?vue&type=script&lang=js"
export * from "./PatientFrictionPage.vue?vue&type=script&lang=js"
import style0 from "./PatientFrictionPage.vue?vue&type=style&index=0&id=113ed015&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113ed015",
  null
  
)

export default component.exports